import React, { useState } from "react";
import { MoreVert, ModeEdit, CancelOutlined, CheckCircleOutlineOutlined } from "@mui/icons-material";
import { Grid, Box, IconButton, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, Divider, Paper, TextField, Card, CardHeader, Avatar, CardContent, Button, Popover, DialogTitle, TextareaAutosize, Stack, Alert } from "@mui/material";

import { axiosFetch } from "../../../../utils/AxiosFetch";
import PopupState, { bindToggle, bindPopover } from "material-ui-popup-state";
import { useNavigate, useParams } from "react-router";
import moment from "moment";
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from "react-redux";
import { ViewComments } from '../ViewComments/Index'
import { SnackbarActions } from "../../../../redux/actions/snackbar.actions";
import { Link } from "react-router-dom";
import { update } from "../../../../redux/actions/updateData.action";
import Select from 'react-select';
import AddIcon from "@mui/icons-material/Add";
import DatePicker from "react-datepicker";
// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import SearchObjectivePopup from "./SearchObjective/SearchObjectivePopup";
import { TimeConversion } from "../../../../utils/TimeConversion";
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import FileUpload from "../ViewOKR/FileUpload";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';


const KeyResults = (props) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  let statusList = useSelector((state) => state.loadStatus_Reducer.statusList);
  let usersList = useSelector((state) => state.loadUsers_Reducer.usersList);

  const [selectedCommentId, setSelectedCommentId] = useState("");
  const [isArchived, setIsArchived] = useState(false);
  const [isOpenComments, setIsOpenComments] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [status, setStatus] = useState(null);
  const [selectAssignee, setSelectAssignee] = useState([])
  const [owner_toEdit, setOwner_toEdit] = useState([]);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [description_toEdit, setDescription_toEdit] = useState("");

  const [participants_toEdit, setParticipants_toEdit] = useState([]);
  const [participants_toEditErrMsg, setParticipants_toEditErrMsg] = useState(false);
  const [selectedKr, setSelectedKr] = useState(null);
  const [title_toEditErrMsg, setTitle_toEditErrMsg] = useState(false);
  const [description_toEditErrMsg, setDesciption_toEditErrMsg] = useState(false);
  const [selectedOwner_totEditErrMsg, setSelectedOwner_toEditErrMsg] = useState(false);
  const [selectedStatus_toEditErrMsg, setSelectedStatus_toEditErrMsg] = useState(false);
  const [dueDate_toEditErrMsg, setDueDate_toEditErrMsg] = useState(false);
  const [isShowDefaultValue, setIsShowDefaultValue] = useState(true);
  const [isObjective, setIsObjective] = useState(false);

  const [isRestrictTitleUpdate, setIsRestrictTitleUpdate] = useState(true);
  const [isRestrictParticipantUpdate, setIsRestrictParticipantUpdate] = useState(true);
  const [isErrorParticipant, setIsErrorParticipant] = useState(false);
  const [isErrorOwner, setIsErrorOwner] = useState(false);


  var userDetails =
    localStorage.getItem("argus_user") !== null
      ? localStorage.getItem("argus_user")
      : null;

  var userType =
    userDetails !== null && JSON.parse(userDetails).usertype !== null
      ? JSON.parse(userDetails).usertype
      : "";
  var userid =
    userDetails !== null && JSON.parse(userDetails).userid !== null
      ? JSON.parse(userDetails).userid
      : "";


  const [value, setValue] = useState('0');

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [comment_anchorEl, setComment_AnchorEl] = React.useState(null);
  const comment_open = Boolean(comment_anchorEl);
  const [openDialog, setOpenDialog] = useState(false);
  const [objectiveDialog, setObjectiveDialog] = useState(false);
  const [dueDate, setDueDate] = useState("");
  const [dueDate_toEdit, setDueDate_toEdit] = useState(new Date());
  const [ownersErrMsg, setOwnersErrMsg] = useState(false);
  const [selectedKrId, setSelectedKrId] = useState("");
  const [isKRArchived, setIsKRArchived] = useState(false);
  const [title_toEdit, setTitle_toEdit] = useState("");
  const [maxWidth, setMaxWidth] = React.useState('md');
  const [openObjPopup, setOpenObjPopup] = React.useState(false);


  const toggleSearchObjPopup = (param) => {
    if (param === undefined) {
      setOpenObjPopup(true);
    }
    else {
      setOpenObjPopup(param);
    }
  }

  const handleClick = (event, kr) => {

    setSelectedKr(kr);
    setSelectedKrId(kr.id);
    setIsKRArchived(kr.isArchived);
    setIsObjective(kr.isObjective);
    setAnchorEl(event.currentTarget);

  };

  const handleChangeTitle = (e) => {


    setTitle_toEdit(e.target.value);
    setTitle_toEditErrMsg(false);
  }

  const handleTitleUpdate = (id) => {

    if (title_toEdit === "") {
      setTitle_toEditErrMsg(true);
      return false;
    }

    var req = {
      "itemId": id,
      "tableName": "OKRObjects,OKRAssignments,OKRAttachments",
      "fieldName": "title",
      "typeId": 2,
      "value": title_toEdit
    }
    dispatch(update(req));
    if(props.pageNo > 1){
      props.handlePageChange(1);
    }
    dispatch(SnackbarActions(true, "success", "Updated Successfully"))
    var close = document.getElementById("closebtn");
    close.click();
    props.loadKeyResults();
  };

  const handleChangeDescription = (e) => {
    setDescription_toEdit(e.target.value);
    setDesciption_toEditErrMsg(false);
  }
  const handleDescriptionUpdate = (id) => {
    if (description_toEdit === "") {
      setDesciption_toEditErrMsg(true);
      return false;
    }
    var req = {
      "itemId": id,
      "tableName": "OKRObjects,OKRAssignments,OKRAttachments",
      "fieldName": "description",
      "value": description_toEdit,
      "typeId": 2
    }

    dispatch(update(req));
    if(props.pageNo > 1){
      props.handlePageChange(1);
    }
    dispatch(SnackbarActions(true, "success", "Updated Successfully"))
    var close = document.getElementById("closebtn");
    close.click();
    props.loadKeyResults();
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick_comment = (event, id) => {
    setSelectedCommentId(id);
    setComment_AnchorEl(event.currentTarget);
  };

  const handleClose_comment = () => {
    setComment_AnchorEl(null);
  };

  const handleChangeDueDate = (date) => {
    setDueDate_toEdit(date);
    setDueDate_toEditErrMsg(false);
  }
  const handleDueDateUpdate = (id) => {
    if (dueDate_toEdit === "") {
      setDueDate_toEditErrMsg(true);
      return false;
    }

    var req = {
      "itemId": parseInt(id),
      "tableName": "OKRObjects,OKRAssignments,OKRAttachments",
      "fieldName": "dueDate",
      "typeId": 2,
      "value": moment(dueDate_toEdit).format('YYYY-MM-DD')
    }
    dispatch(update(req));
    if(props.pageNo > 1){
      props.handlePageChange(1);
    }
    dispatch(SnackbarActions(true, "success", "Updated Successfully"))
    var close = document.getElementById("closebtn");
    close.click();
    props.loadKeyResults();

    setDueDate(dueDate_toEdit);
  };

  const handleCompletionPercentageUpdate = (id,percentage) => {
    if(percentage !== 0 || parseInt(value) !== 0){
      var req = {
        "itemId": id,
        "tableName": "OKRObjects,OKRAssignments,OKRAttachments",
        "fieldName": "completionPercentage",
        "typeId": 2,
        "value": parseInt(value) !== 0 ? value.toString() : percentage!== null?percentage.toString():"0"
      }
      if(props.pageNo > 1){
        props.handlePageChange(1);
      }
      dispatch(update(req));
      dispatch(SnackbarActions(true, "success", "Updated Successfully"))
      var close = document.getElementById("closebtn");
      close.click();
      props.loadKeyResults();
      props.loadBasicOKRDetails();
    }
    else{
      var close = document.getElementById("closebtn");
      close.click();
    }
  }
  const assignAsOKR = () => {
    setAnchorEl(null);
    let selectedOwnersId;


    if (selectAssignee.length !== 0) {
      selectedOwnersId = selectAssignee.map((options) => options.value).toString();
    }


    if (selectAssignee.length === 0) {
      setOwnersErrMsg(true);
      return false;
    }
    axiosFetch({
      method: "post",
      url: "/okrs/assign",
      requestConfig: {
        OkrIds: selectedKrId.toString(),
        // 1-OKR, 2- KR
        assignmentTypeId: 1,
        assignedUserId: selectAssignee.length !== 0 ? selectedOwnersId : null,
        ObjectiveId: parseInt(id)
      },
    })
      .then((res) => {
        setAnchorEl(null);
        setObjectiveDialog(false);
        if (res.status === 200) {
          if (res.data === "success") {
            // handleClose();
            dispatch(
              SnackbarActions(true, "success", "KR Assigned Successfully!")
            );
            if (props.pageNo === 1) {
              props.loadKeyResults();
            }
            else {

              props.handlePageChange(1);
            }
          }
        } else if (res.status === 400) {
          dispatch(
            SnackbarActions(true, "error", "Something Went Wrong!")
          );
        }
        else if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((err) => console.error(err));
  };

  const openConfirmPopup = () => {
    setComment_AnchorEl(null);
    setOpenDialog(true);
  };

  const handleChangeOwner = (selected) => {

    if (selected.length !== 0) {
      setOwnersErrMsg(false);
    }
    else if (selected.length === 0) {
      setOwnersErrMsg(true);
      setSelectAssignee(selected);
      return false;
    }
    setSelectAssignee(selected);
  }



  const closeConfirmPopup = () => {
    setOpenDialog(false);
  };

  const closeArchiveDialog = () => {
    setOpenArchiveDialog(false)
  };

  const closeObjectivePopup = () => {
    setObjectiveDialog(false);
  }

  const openObjectivePopup = () => {

    if (selectedKr.objectiveOwners !== undefined && selectedKr.objectiveOwners !== null && selectedKr.objectiveOwners.length !== 0) {

      setSelectAssignee(usersList.filter(user => {
        return selectedKr.objectiveOwners.some(owner => {
          return parseInt(user.value) == parseInt(owner.ownerId)
        })
      }));

    }
    else {
      setSelectAssignee([]);
    }
    setObjectiveDialog(true);
    setAnchorEl(null);
  }

  const toggleViewComments = (param) => {

    if (param !== undefined && typeof (param) === 'boolean') {
      setIsOpenComments(false);
    }
    else {
      setSelectedKrId(param);
      setIsOpenComments(true);
    }
  }
  const archiveTheKR = () => {
    setAnchorEl(null);
    axiosFetch({
      method: "post",
      url: "/OKRs/okr/archive",
      requestConfig: {
        objectId: selectedKrId,
        assignmentTypeId: 2,
        isArchived: !isKRArchived,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          isKRArchived ? dispatch(SnackbarActions(true, "success", "KR UnArchived!")) : dispatch(SnackbarActions(true, "success", "KR Archived!"))
          if (props.pageNo === 1) {
            props.loadKeyResults();
          }
          else {

            props.handlePageChange(1);
          }
        }
        else if (res.status === 400) {
          let response = res.data;
          dispatch(SnackbarActions(true, "warning", response))
        }
        else if (res.status === 401) {
          navigate("/");
        }
      })
      .catch((err) => console.error(err));
  };

  const handleComments = (krId) => {
    setSelectedKrId(krId);
    props.toggleCommentsPopup(krId);
  }

  const handleChangeCompletionSlider = (e) => {
    setIsShowDefaultValue(false);
    setValue(e.target.value);
  }

  const handleDelete = () => {
    axiosFetch({
      method: "delete",
      url: `/OKRs/okr/comment/${selectedCommentId}`
    })
      .then((res) => {
        if (res.status === 200) {

          setOpenDialog(false);
          dispatch(SnackbarActions(true, "success", "Comment Deleted"));
          if (props.pageNo === 1) {

            props.loadKeyResults();
          }
          else {

            props.handlePageChange(1);
          }


        }
        else if (res.status === 400) {
          setOpenDialog(false);
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })

      .catch(err => console.error(err));





  }

  const handleChangeOwner_toEdit = (arr, kr) => {

    if (arr.length !== 0 && (kr.participants.length !== 0 && kr.participants.filter(participant => participant.id == arr[arr.length - 1].value).length !== 0)) {
      setIsRestrictTitleUpdate(true);
      setIsErrorOwner(true);
      return false;
    }
    else {
      setIsRestrictTitleUpdate(false);
      setOwner_toEdit(arr);
      setIsErrorOwner(false);
      setSelectedOwner_toEditErrMsg(false);
    }
    setIsErrorOwner(false);
  }

  const handleChangeParticipants_toEdit = (arr, kr) => {
    if (arr.length !== 0 && (kr.owners.length !== 0 && kr.owners.filter(owner => owner.id == arr[arr.length - 1].value).length !== 0)) {
      setIsRestrictParticipantUpdate(true);
      setIsErrorParticipant(true);
      return false;
    }
    else {
      setIsRestrictParticipantUpdate(false);
      setIsErrorParticipant(false);
      setParticipants_toEdit(arr);
      setParticipants_toEditErrMsg(false);
    }
    setIsErrorParticipant(false);
  }

  const handleParticipantsUpdate = (krId) => {

    setIsRestrictParticipantUpdate(true);
    let participantIds = '';

    if (participants_toEdit.length === 0) {
      setParticipants_toEditErrMsg(true);
      return false;
    } else {
      participantIds = participants_toEdit.map(participant => participant.value).toString();
      console.log(participantIds);
      axiosFetch({
        method: "post",
        url: "/data/update",
        requestConfig: {
          "itemId": krId,
          "tableName": "OKRObjects",
          "fieldName": "ParticipantIds",
          "typeId": 2,
          "value": participants_toEdit.length !== 0 ? participantIds : null,
        }
      })

        .then((res) => {
          if (res.status === 200) {
            if (res.data === 'success') {
              dispatch(SnackbarActions(true, "success", "Updated Successfully"));
              var close = document.getElementById("closebtn");
              close.click();
              setIsRestrictParticipantUpdate(false);
            }
            props.loadBasicOKRDetails();
            props.loadKeyResults();
          }

          else if (res.status === 401) {
            navigate('/');
          }
        })
        .catch(err => console.error(err));
    }


  }
  const handleOwnerUpdate = (krId) => {

    setIsRestrictTitleUpdate(true);
    let ownersIds = '';


    if (owner_toEdit.length === 0) {
      setSelectedOwner_toEditErrMsg(true);
      return false;
    }

    else {

      ownersIds = owner_toEdit.map(owner => owner.value).toString();

      axiosFetch({
        method: "post",
        url: "/okrs/assign",
        requestConfig: {
          OkrIds: krId.toString(),
          assignmentTypeId: 2,
          assignedUserId: owner_toEdit.length !== 0 ? ownersIds : null,
          ObjectiveId: parseInt(id)
        }
      })
        .then((res) => {

          if (res.status === 200) {
            if (res.data === 'success') {
              dispatch(SnackbarActions(true, "success", "Updated Successfully"));
              var close = document.getElementById("closebtn");
              close.click();
              setIsRestrictTitleUpdate(false);
            }
            props.loadBasicOKRDetails();
            props.loadKeyResults();
          }
          else if (res.status === 400) {
            dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
          }
          else if (res.status === 401) {
            navigate('/');
          }
        })

        .catch(err => console.error(err));
    }

  };

  const deleteAttachment = (file, type) => {

    console.log(file)
    axiosFetch({
      method: "post",
      url: `/OKRs/okr/update/attachment`,
      requestConfig: {
        "id": file.attachmentId,
        "isFileOrUrl": type === 0 ? true : false,
        "value": type === 0 ? file.physicalName : file.url
      }
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(SnackbarActions(true, "success", "Deleted Successfully!"));
          props.loadKeyResults();

        }
        else if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
        }
        else if (res.status === 401) {
          navigate('/');
        }
      })
  }


  const handleChangeStatus = (obj) => {
    setSelectedStatus(obj);
    setSelectedStatus_toEditErrMsg(false);
  }

  const handleChangeStatus_toEdit = (obj) => {
    setSelectedStatus(obj);
    setSelectedStatus_toEditErrMsg(false);
  }
  const handleStatusUpdate = (id) => {

    if (selectedStatus === null) {
      setSelectedStatus_toEditErrMsg(true);
      return false;
    }
    setStatus(selectedStatus.label);
    var req = {
      "itemId": id,
      "tableName": "OKRObjects,OKRAssignments,OKRAttachments",
      "fieldName": "statusId",
      "typeId": 2,
      "value": selectedStatus.value
    }
    dispatch(update(req));
    setStatus(null);
    dispatch(SnackbarActions(true, "success", "Updated Successfully"))
    var close = document.getElementById("closebtn");
    close.click();
    props.loadKeyResults();
  };


  return (
    <>

      {openObjPopup ? (<SearchObjectivePopup toggleSearchObjPopup={toggleSearchObjPopup} open={openObjPopup} loadKeyResults={props.loadKeyResults} />) : ("")}

      {isOpenComments ? <ViewComments toggleViewComments={toggleViewComments} open={isOpenComments} krId={selectedKrId} toggleCommentsPopup={props.toggleCommentsPopup} /> : null}

      <Box className="kr-box">
        <Grid container spacing={2}>
          <Grid xs={6}>
            {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" :
              userType === "Admin"
                || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0)
                ? <Button className="tabs-add theme-btn" onClick={() => props.toggleOkrPopup("1", id)}>Add Key Result</Button> : ""}
          </Grid>
          <Grid xs={6}>
            {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" :
              userType === "Admin"
                || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0)
                ? <Button className="theme-btn tabs-add" sx={{ right: "155px" }} onClick={() => toggleSearchObjPopup()}>Add Key Results from Existing Objective</Button> : ""}
          </Grid>
          {/* <Grid item xl={12} lg={12} md={12} xs={12} sx={{ paddingTop: "0px !important", transform: "translate(-143px, -66px)" }}>
            </Grid> */}

          {props && props.items !== undefined && props.items.length !== 0 ? props.items.map((kr, index) => (
            <Grid item xl={12} lg={12} md={12} xs={12}>
              {/* style={{ backgroundColor: kr.isArchived ? "grey" : "white" }}  */}
              <div className="krbox" style={{ backgroundColor: kr.isArchived ? "#edeaea" : "white" }}>
                <div className="argus-kr-box">
                  {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                    || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                    || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                    || (kr.users.owners.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                    || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                    || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ? < MoreVert className="kr-option stensil-ignore" onClick={(e) => handleClick(e, kr)} /> : (
                    ""
                  ) : ("")}
                  <small className="stensil kr-index">KR {index + 1} </small>
                  {/* {kr.isObjective ? <a href={`/viewokr/${kr.id}`}>This Key result has also been assigned as objective for {kr.ownerName !== null ? kr.ownerName : ""}</a> : ""} */}
                  <div className="kr-editabel" style={{ borderBottom: '1px solid #f1f1f1', paddingBottom: '5px', marginBottom: '13px' }}>
                    <h3 className="stensil kr-heading">{kr.title !== null ? `(#${kr.id})` + " " + kr.title : ""}</h3>
                    {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : userType === "Admin"
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                      || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (kr.users.owners.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                      // <Grid item xs={12}>
                      <PopupState variant="popper" className="okr-edit-button" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit" style={{ display: "inline-block" }}>
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                            >
                              <ModeEdit color="secondary" fontSize="inherit" className="position-relative" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup stensil-ignore">

                              <Paper>
                                <TextField
                                  id="filled-basic"
                                  placeholder="Key Result Title"
                                  variant="outlined"
                                  // value={title_toEdit}
                                  defaultValue={kr.title !== null ? kr.title : ""}
                                  onChange={handleChangeTitle}
                                  multiline
                                  fullWidth
                                  rows={5}
                                />
                                <p>{title_toEditErrMsg ? "Please enter valid title" : ""}</p>
                                <IconButton color="success" disabled={title_toEdit===""?true:false}>
                                  <CheckCircleOutlineOutlined
                                    onClick={() => handleTitleUpdate(kr.id)}
                                  />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                      // </Grid>
                      : (
                        ""
                      )}
                  </div>
                  {kr.isObjective ? <div className="kr-editabel">
                    <div className="custom-alert stensil-ignore"><InsertLinkIcon /> This key result has also been assigned as&#160;<a href={`/viewokr/${kr.id}`}> objective {`(#${kr.id})`}</a>&nbsp;
                      {kr.objectiveOwners !== undefined && kr.objectiveOwners.length !== 0 ? "for" : ""}
                      {kr.objectiveOwners !== undefined && kr.objectiveOwners.length !== 0 ?
                        kr.objectiveOwners.map((owner, index) =>
                          <>
                            &nbsp;<Link to={`/users-profile/${owner.ownerId}`}>{owner.ownerName}{index + 1 !== kr.objectiveOwners.length ? "," : ""}</Link>
                          </>) : ""}
                    </div>
                  </div> : ""}
                  <div className="kr-editabel">
                    <p className="stensil-para kr-desc" style={{ fontSize: "13px" }}>Description : {kr.description !== null ? kr.description : "-"}</p>
                    {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : userType === "Admin"
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                      || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                      // <Grid item xs={12}>
                      <PopupState variant="popper" className="okr-edit-button" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button" style={{ display: "inline-block" }}>
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                            >
                              <ModeEdit color="secondary" fontSize="inherit" className="position-relative" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup description-custom-popup">

                              <Paper>
                                <TextareaAutosize
                                  id="filled-basic"
                                  className="desc-okr"
                                  label="Description"
                                  variant="filled"
                                  defaultValue={kr.description !== null ? kr.description : title_toEdit}
                                  onChange={handleChangeDescription}

                                />
                                <p>{description_toEditErrMsg ? "Please enter valid description" : ""}</p>
                                <IconButton color="success" disabled={description_toEdit ===""?true:false}>
                                  <CheckCircleOutlineOutlined
                                    onClick={() => handleDescriptionUpdate(kr.id)}
                                  />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                      // </Grid>
                      : (
                        ""
                      )}
                  </div>
                  <div className="kr-editabel">
                    <p className="stensil">Owner's Name : {kr.users.owners.length !== 0 ? kr.users.owners.map((owner, index) => (<Link className="ownername" to={`/users-profile/${owner.id}`}>{owner.firstName + " " + owner.lastName}{index + 1 !== kr.users.owners.length ? "," : ""}</Link>)) : "-"}</p>
                    {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                      || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                      // <Grid item xs={12}>
                      <PopupState variant="popper" className="okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                            >
                              <ModeEdit color="secondary" fontSize="inherit" className="position-relative" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup">
                              <Paper >
                                <Select
                                  placeholder="Select Owners"
                                  name="Owners"
                                  menuPortalTarget={document.body}
                                  menuPosition={'fixed'}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  // value={owner_toEdit}
                                  defaultValue={kr.users.owners.length !== 0 ? props && props.krUserList !== undefined && props.krUserList.filter(user => {
                                    return kr.users.owners.some(owner => {
                                      return user.value === owner.id.toString()
                                    })
                                  }) : ""}
                                  options={props && props.krUserList !== undefined ? props.krUserList : ""}
                                  onChange={(arr) => handleChangeOwner_toEdit(arr, kr.users)}
                                  isMulti={true}
                                />
                                <p>{selectedOwner_totEditErrMsg ? "Please select any" : ""}</p>
                                <p>{isErrorOwner ? "Owner & Participant can't be same person" : ""}</p>
                                <IconButton
                                  disabled={isRestrictTitleUpdate}
                                  color="success"
                                  onClick={() => handleOwnerUpdate(kr.id)}
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                      // </Grid>
                      : (
                        ""
                      ) : (
                      ""
                    )}
                  </div>
                  <div className="kr-editabel">
                    <p className="stensil">Participant's Name : {kr.users.participants.length !== 0 ? kr.users.participants.map((participant, index) => <Link className="ownername" to={`/users-profile/${participant.id}`}>{participant.firstName + " " + participant.lastName}{index + 1 !== kr.users.participants.length ? "," : ""}</Link>) : "-"}</p>
                    {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                      || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                      // <Grid item xs={12}>
                      <PopupState variant="popper" className="okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                            >
                              <ModeEdit color="secondary" fontSize="inherit" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} className="edit-popup" transition>
                              <Paper>
                                <Select
                                  placeholder="Select Participants"
                                  name="Participants"
                                  // value={participants_toEdit}
                                  menuPortalTarget={document.body}
                                  menuPosition={'fixed'}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  defaultValue={kr.users.participants.length !== 0 ? props.krUserList.filter(user => {
                                    return kr.users.participants.some(owner => {
                                      return user.value === owner.id.toString()
                                    })
                                  }) : ""}
                                  options={props && props.krUserList !== undefined ? props.krUserList : ""}
                                  onChange={(arr) => handleChangeParticipants_toEdit(arr, kr.users)}
                                  isMulti={true}
                                />
                                <p>{participants_toEditErrMsg ? "Please select any" : ""}</p>
                                <p>{isErrorParticipant ? "Owner & Participant can't be same person" : ""}</p>
                                <IconButton
                                  disabled={isRestrictParticipantUpdate}
                                  color="success"
                                  onClick={() => handleParticipantsUpdate(kr.id)}
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                      // </Grid>
                      : (
                        ""
                      ) : (
                      ""
                    )}
                  </div>
                  <div className="kr-editabel">
                    <p className="stensil">Status :  {kr.statusName !== null ? kr.statusName : "-"} </p>

                    {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                      || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                      // <Grid item xs={6}>
                      <PopupState variant="popper" className="okr-edit" popupId="demo-popup-popper">
                        {(popupState) => (
                          <div className="okr-edit-button">
                            <IconButton
                              aria-label="edit"
                              size="small"
                              {...bindToggle(popupState)}
                            >
                              <ModeEdit color="secondary" fontSize="inherit" className="position-relative" />
                            </IconButton>
                            <Popover {...bindPopover(popupState)} transition className="edit-popup">

                              <Paper>
                                <Select
                                  placeholder="Select Status"
                                  name="Status"
                                  menuPortalTarget={document.body}
                                  menuPosition={'fixed'}
                                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                  // value={selectedStatus}
                                  defaultValue={kr.statusName !== null ? statusList.filter(status => {
                                    return kr.statusName === status.label
                                  }) : ""}
                                  options={statusList}
                                  onChange={handleChangeStatus_toEdit}
                                />
                                <p>{selectedStatus_toEditErrMsg ? "Please select any" : ""}</p>
                                <IconButton
                                  color="success"
                                  onClick={() => handleStatusUpdate(kr.id)}
                                >
                                  <CheckCircleOutlineOutlined />
                                </IconButton>
                                <IconButton
                                  id="closebtn"
                                  sx={{ color: "red" }}
                                  {...bindToggle(popupState)}
                                >
                                  <CancelOutlined />
                                </IconButton>
                              </Paper>

                            </Popover>
                          </div>
                        )}
                      </PopupState>
                      // </Grid>
                      : (
                        ""
                      ) : (
                      ""
                    )}
                  </div>
                  <div>
                    Attachments : <br />
                    {kr.attachments !== undefined && kr.attachments.length !== 0 ? kr.attachments.map((file, index) => (<>{file.actualFileName !== null ? (<span class="attach kr-attach"><InsertDriveFileIcon className="icon" /><a href={`/api/uploads/file/download/${file.physicalName}`} className="ownername"> {file.actualFileName}</a>
                      {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                        || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                        <Button className="delete-btn" onClick={() => deleteAttachment(file, 0)}><DeleteIcon className="icon" /></Button> : "" : ""}
                    </span>) : ""}{file.url !== null ? <span class="attach kr-attach"><AttachFileIcon className="icon" /><a href={`${file.url}`} target="_blank">{`${file.url !== null && file.actualFileName !== null ? ":" + file.url : file.url}`}</a>
                      {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                        || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                        <Button className="delete-btn" onClick={() => deleteAttachment(file, 1)}><DeleteIcon className="icon" /></Button> : "" : ""}</span> : ""}</>)) : ("")}

                    <span className="upload-btn" style={{ marginTop: "20px" }}>{(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                      || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                      || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                      <FileUpload className="icon" okrId={kr.id} loadOKR={props.loadKeyResults} /> : (
                        ""
                      ) : (
                      ""
                    )}</span>
                  </div><br />
                  <div className="argus-kr-prog">
                    <div className="stensil-ignore">
                      <input
                        type="range"
                        step={5}
                        min={5}
                        value={kr.completionPercentage !== null ? kr.completionPercentage : 0}
                        // defaultValue={kr.completionPercentage !== null ? kr.completionPercentage : 0}
                        disabled={true}
                        onChange={(e) => setValue(e.target.value)}
                      />
                      {kr.completionPercentage !== null ? kr.completionPercentage : 0}%
                      {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                        || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                        <PopupState variant="popper" popupId="demo-popup-popper">
                          {(popupState) => (
                            <div className="okr-edit" style={{ display: 'inline' }}>
                              <IconButton
                                aria-label="edit"
                                size="small"
                                {...bindToggle(popupState)}
                              >
                                <ModeEdit color="secondary" fontSize="inherit" className="position-relative" />
                              </IconButton>
                              <Popover {...bindPopover(popupState)} transition className="edit-popup">

                                <Paper>
                                  <label>Change Completion Percentage</label>
                                  <br />
                                  <input
                                    type="range"
                                    step={5}
                                    min={5}
                                    // value={value}
                                    oninput="this.nextElementSibling.value = this.value"
                                    defaultValue={kr.completionPercentage !== null ? kr.completionPercentage : 0}
                                    onChange={handleChangeCompletionSlider}
                                  />
                                  <output>{isShowDefaultValue ? kr.completionPercentage !== null ? kr.completionPercentage : 0 : value}%</output>
                                  {/* {value ? value + "%" : null} */}
                                  <br />
                                  <IconButton
                                    onClick={() => handleCompletionPercentageUpdate(kr.id,kr.completionPercentage)}
                                    color="success"
                                  >
                                    <CheckCircleOutlineOutlined />
                                  </IconButton>
                                  <IconButton
                                    id="closebtn"
                                    sx={{ color: "red" }}
                                    {...bindToggle(popupState)}
                                  >
                                    <CancelOutlined />
                                  </IconButton>
                                </Paper>

                              </Popover>
                            </div>
                          )}
                        </PopupState>
                        : (
                          ""
                        ) : (
                        ""
                      )}

                      <span className="stensil"> | &nbsp; Due Date :{kr.dueDate !== null ? moment(kr.dueDate).format('MMM-DD-YYYY') : "-"} </span>
                      {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : !kr.isObjective ? userType === "Admin"
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                        || (kr.users.owners.length !== 0 && kr.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (kr.users.participants.length !== 0 && kr.users.participants.filter(participant => participant.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                        // <Grid item xs={12}>
                        <PopupState variant="popper" popupId="demo-popup-popper">
                          {(popupState) => (
                            <div className="okr-edit-button">
                              <IconButton
                                aria-label="edit"
                                size="small"
                                {...bindToggle(popupState)}
                              >
                                <ModeEdit color="secondary" fontSize="inherit" className="position-relative" />
                              </IconButton>
                              <Popover {...bindPopover(popupState)} transition className="edit-popup">

                                <Paper>
                                  <DatePicker
                                    // minDate={moment().toDate()}
                                    placeholderText="Due Date"
                                    value={dueDate_toEdit}
                                    fullWidth
                                    className="datetime"
                                    dateFormat="MMM-dd-yyyy"
                                    selected={dueDate_toEdit}
                                    popperPlacement="top"
                                    popperModifiers={{
                                      flip: {
                                        behavior: ["bottom"] // don't allow it to flip to be above
                                      },
                                      preventOverflow: {
                                        enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                      },
                                      hide: {
                                        enabled: false // turn off since needs preventOverflow to be enabled
                                      }
                                    }}

                                    onSelect={(date) => {
                                      handleChangeDueDate(date)
                                    }}
                                  />
                                  {/* <DatePicker
                                    minDate={moment().toDate()}
                                    placeholderText="Due Date"
                                    selected={kr.dueDate !== null ? new Date(kr.dueDate) : new Date()}
                                    dateFormat="dd-MM-yyyy"
                                    onSelect={(date) => handleChangeDueDate(date)}
                                  /> */}
                                  {/* <TextField
                                    id="filled-basic"
                                    variant="filled"
                                    type="date"
                                    defaultValue={kr.dueDate !== null ? kr.dueDate : ""}
                                    onChange={handleChangeDueDate}

                                  /> */}
                                  <p>{dueDate_toEditErrMsg ? "Please select any" : ""}</p>
                                  <IconButton
                                    onClick={() => handleDueDateUpdate(kr.id)}
                                    color="success"
                                  >
                                    <CheckCircleOutlineOutlined />
                                  </IconButton>
                                  <IconButton
                                    id="closebtn"
                                    sx={{ color: "red" }}
                                    {...bindToggle(popupState)}
                                  >
                                    <CancelOutlined />
                                  </IconButton>
                                </Paper>

                              </Popover>
                            </div>
                          )}
                        </PopupState>

                        // </Grid>

                        : (
                          ""
                        ) : (
                        ""
                      )}
                    </div>
                    <div>
                      {(props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.isArchived !== undefined && props.basic_OkrDetails.isArchived) ? "" : userType === "Admin"
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.createdby !== undefined && props.basic_OkrDetails.createdby === userid)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.owners.length !== 0 && props.basic_OkrDetails.users.owners.filter(owner => owner.id === userid).length !== 0)
                        || (props && props.basic_OkrDetails !== undefined && props.basic_OkrDetails !== null && props.basic_OkrDetails.users !== undefined && props.basic_OkrDetails.users.participants.length !== 0 && props.basic_OkrDetails.users.participants.filter(participant => participant.id === userid).length !== 0) ?
                        <Button className="theme-btn float-left stensil-ignore" style={{ marginRight: "5px" }} onClick={() => handleComments(kr.id)}>Add Comment</Button> : ""}
                      {kr.comments.length !== 0 && kr.comments[0].commentsCount > 2 ? <Button className="theme-btn float-left" variant="contained" onClick={() => toggleViewComments(kr.id)}>Show More</Button> : ""}
                    </div>
                  </div>
                  <Divider />
                  {kr.comments.length !== 0 ? <h5 className="comment-t">Comments: </h5> : null}
                  {kr.comments.length !== 0 && kr.comments.map((comments) => (
                    <Grid item xs={12}>
                      <Card sx={{ position: "relative", padding: "10px", marginBottom: "10px", backgroundColor: kr.isArchived ? "#f3f3f3" : "white" }}>
                        <CardHeader avatar={<Avatar aria-label="recipe">
                          <Link to={`/ users - profile / ${comments.createdBy}`}> {comments.createdByName !== null ? comments.createdByName.charAt(0) : ""}</Link>
                        </Avatar>}
                          action={<MoreVert className="card-option-kr" onClick={(e) => handleClick_comment(e, comments.id)} />}
                          title={comments.createdByName !== null ? <Link className="comment-created" to={`/ users - profile / ${comments.createdBy}`}>{comments.createdByName}</Link> : ""}
                          subheader={comments.createdDate !== null ? "created on " + TimeConversion(comments.createdDate, 2) : ""}
                        />
                        <Divider />
                        <CardContent sx={{ marginTop: "10px" }}> {comments.comment !== null ? comments.comment : null}</CardContent>
                      </Card>
                    </Grid>
                  ))}
                </div>
              </div>
            </Grid>
          )) : <Stack sx={{ width: '100%', margin: "10px" }} spacing={2}>
            <Alert severity="error">No Key Results Found!</Alert></Stack>}


        </Grid>
      </Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={openObjectivePopup} disabled={isKRArchived}><AddIcon /> Assign as Objective</MenuItem>
        <Divider />
        <MenuItem onClick={archiveTheKR} disabled={isObjective}> <DeleteIcon /> {isKRArchived ? "UnArchive" : " Archive"}</MenuItem>
      </Menu>

      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={comment_anchorEl}
        open={comment_open}
        onClose={handleClose_comment}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >

        <MenuItem>
          <IconButton onClick={openConfirmPopup}>
            <DeleteIcon />
            Delete
          </IconButton></MenuItem>
      </Menu>

      <Dialog
        open={openDialog}
        onClose={closeConfirmPopup}
        aria-describedby="alert-dialog-slide-description"
        className="small-info-popup"
        maxWidth={maxWidth}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmPopup} className="theme-btn cancel-btn">No</Button>
          <Button onClick={handleDelete} className="theme-btn">Yes</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={objectiveDialog}
        onClose={closeObjectivePopup}
        aria-describedby="alert-dialog-slide-description"
        // className="small-info-popup"
        fullWidth="lg"
        maxWidth="sm"
      >
        <DialogTitle className="modal-heading">Assign As Objective</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Select
              placeholder="Select Assignee"
              name="users"
              options={usersList}
              value={selectAssignee}
              onChange={handleChangeOwner}
              isMulti={true}
              menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
            <p>{ownersErrMsg ? "Please fill out this filed" : ""}</p>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={closeObjectivePopup} className="theme-btn cancel-btn no-btn">No</Button>
          <Button onClick={assignAsOKR} className="theme-btn yes-btn">Yes</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openArchiveDialog}
        onClose={closeArchiveDialog}
        aria-describedby="alert-dialog-slide-description"
        className="small-info-popup"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {isArchived ? "Are you sure you want to UnArchive?" : "Are you sure you want to Archive?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeArchiveDialog} className="no-btn">No</Button>
          <Button onClick={archiveTheKR} className="yes-btn">Yes</Button>
        </DialogActions>
      </Dialog>



    </>
  );
};
export default KeyResults;
